/*
 *
 * Account constants
 *
 */

export const ACCOUNT_CHANGE = 'src/Account/ACCOUNT_CHANGE';
export const FETCH_PROFILE = 'src/Account/FETCH_PROFILE';
export const CLEAR_ACCOUNT = 'src/Account/CLEAR_ACCOUNT';
export const SET_PROFILE_LOADING = 'src/Account/SET_PROFILE_LOADING';


export const CREATE_BANK = 'src/Account/CREATE_BANK';
export const FETCH_BANK = 'src/Account/FETCH_BANK';
export const DELETE_BANK = 'src/Account/DELETE_BANK';
export const RESET_BANK = 'src/Account/RESET_BANK';
export const RESET_BANK_FORM_ERROR = 'src/Account/RESET_BANK_FORM_ERROR';
export const SET_BANK_FORM_ERROR = 'src/Account/SET_BANK_FORM_ERROR';
export const SET_PROFILE_EDIT_ERRORS = 'src/Account/SET_PROFILE_EDIT_ERRORS';

export const PASSWORD_CHANGE = 'src/Account/PASSWORD_CHANGE';
export const RESET_PASSWORD_RESET = 'src/Account/RESET_PASSWORD_RESET';
export const SET_RESET_PASSWORD_FORM_ERRORS = 'src/Account/SET_RESET_PASSWORD_FORM_ERRORS';
export const SET_TWO_FACTOR = 'src/Account/SET_TWO_FACTOR';
export const SET_TWO_FACTOR_CODE = 'src/Account/SET_TWO_FACTOR_CODE';
export const TWO_FACTOR_ERROR = 'src/Account/TWO_FACTOR_ERROR';
export const SHOW_TWO_FA_SETUP = 'src/Account/SHOW_TWO_FA_SETUP';
export const CLEAR_TWO_FACTOR = 'src/Account/CLEAR_TWO_FACTOR';
export const FETCHED_BANKS = 'src/Account/FETCHED_BANKS';